/* eslint-disable no-param-reassign */

// In config, first level keys should be named after the routes names
// in order to use the shorten $content computed property
const config = require('./config');
const collections = require('./collections');
const products = require('./coins');

products.forEach((product) => {
  product.shortId = product.id;
  product.id = `${product.collection}-${product.shortId}`;
});

// MDP Tools require the products to be on the first route to generate the correspondig HTML
config.routes = [{ id: 'mdp', products }];
config.collections = collections;
module.exports = config;
